/* eslint-disable standard/computed-property-even-spacing */
import maNavbarCategory from '@/components/navbarCategories'
import maButton from '@/components/button-blue'
import maDamagedPiece from './components/damagedPiece'
import maMultidamageForm from './components/multidamageForm'
import maMultidamagePcForm from './components/multidamagePcForm'
import maPhotoclaimForm from './components/photoclaimForm'
import maCalculateSurfaceModal from './components/calculateSurfaceModal'
import userFlowMixin from '@/modules/User/mixins/userFlowMixin'

// store module
import warrantyModule from '@/store/modules/warranty'

// utils
import { cloneDeep } from 'lodash'
import generateUniqueId from '@/utils/generateUniqueId'

// constants
import { INTERIOR_PROPERTY, MULTIDAMAGE } from '@/constants'

// api
import { apiPatchMultiDamages } from '@/modules/Damage/services/damages'

// import event Bus
import maEventBus from '@/components/eventbus/index.js'

// sentry
//import * as Sentry from '@sentry/vue' //Remove Sentry on PRE
// Vuex
import { mapState, mapMutations } from 'vuex'

import flowMixin from '@/modules/Flow/mixins/flowMixin'

// types
import { USER_MODULE_NAME } from '@/modules/User/store/types'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_CLEAR_FORMS,
  WARRANTY_CLEAR_REPORT,
  WARRANTY_CLEAR_REPORT_BY_CATEGORY,
  WARRANTY_CLEAR_REPORT_MURS,
  WARRANTY_CLEAR_SELECTED_DAMAGED_PARTS,
  WARRANTY_UPDATE_MULTIDAMAGE
} from '@/store/types'

const TYPES_BANNED = ['SOL', 'NETTOYAGE']

export default {
  name: 'multidamageList',
  mixins: [flowMixin, userFlowMixin],
  data() {
    return {
      multidamagePieces: [],
      selectedDamageReport: {
        ASSETS: INTERIOR_PROPERTY,
        propertyType: this.$route.params.propertyType,
        PIECE: null
      },
      selectedDamagedPart: null,
      selectedAllDamagedParts: null,
      selectedPieceId: null,
      selectedPieceSurface: null,
      selectedDamageIndex: null,
      btnAddAllDamagesIsDisabled: true,
      loading: false,
      isExpanded: false,
      surfaceModalIsOpen: false,
      materialOptions: [],
      someTypeBanned: false
    }
  },
  components: {
    maNavbarCategory,
    maDamagedPiece,
    maMultidamageForm,
    maMultidamagePcForm,
    maPhotoclaimForm,
    maCalculateSurfaceModal,
    maButton
  },
  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantySinisterId: 'sinisterId',
      stateWarrantyId: 'warrantyId',
      stateIsMultidamage: 'isMultidamage',
      stateMultidamage: 'multidamage',
      stateWarrantyPropertyType: 'propertyType',
      stateWarrantySecondaryId: 'secondaryId',
      stateWarrantyZipCode: 'zipCode',
      stateWarrantyCoordinates: 'coordinates',
      stateWarrantyMoreThanTwoYears: 'moreThanTwoYears',
      stateWarrantyResidentType: 'residentType',
      stateWarrantyDamagedItem: 'damagedItem',
      stateWarrantyCategoryId: 'categoryId',
      stateWarrantySubtypeId: 'subtypeId',
      stateWarrantyDamageTypeLiteral: 'damageTypeLiteral'
    }),
    ...mapState(USER_MODULE_NAME, {
      stateUserId: 'userId',
      stateUserType: 'userType'
    }),

    isPhotoclaimFlow() {
      console.log(this.someTypeBanned)
      return this.getUserFlow === 'photoclaim' && !this.someTypeBanned
    },
    /**
     * Sets the damageType title based on the stateWarrantyDamageTypeLiteral if exists,
     * else it gets it from the local storage
     */
    titleNavBar() {
      const titleLocalStorage = localStorage.getItem('damageTypeLiteral')
      return this.stateWarrantyDamageTypeLiteral
        ? this.stateWarrantyDamageTypeLiteral
        : titleLocalStorage
    },

    isMultidamage() {
      return this.stateIsMultidamage
    },

    sinisterId() {
      return this.stateWarrantySinisterId || sessionStorage.getItem('sinId')
    },
    warrantyId() {
      return this.stateWarrantyId || sessionStorage.getItem('formId')
    },
    propertyType() {
      return this.stateWarrantyPropertyType || this.$route.params.propertyType
    },
    getBtnType() {
      return this.loading ? 'spinnerBtn' : 'functionalBtn'
    }
  },

  methods: {
    ...mapMutations(WARRANTY_MODULE_NAME, {
      mutWarrantyClearForms: WARRANTY_CLEAR_FORMS,
      mutWarrantyClearReport: WARRANTY_CLEAR_REPORT,
      mutWarrantyClearReportMurs: WARRANTY_CLEAR_REPORT_MURS,
      mutWarrantyClearReportByCategory: WARRANTY_CLEAR_REPORT_BY_CATEGORY,
      mutWarrantyClearSelectedDamagedParts:
        WARRANTY_CLEAR_SELECTED_DAMAGED_PARTS,
      mutWarrantyUpdateMultidamage: WARRANTY_UPDATE_MULTIDAMAGE
    }),

    checkFormValid() {
      window.scrollTo(0, 0)
      let disable = false
      this.multidamagePieces.forEach((pieceType) => {
        pieceType.pieces.forEach((piece) => {
          if (!piece.pieceSurface) disable = true
          piece.damagedParts.forEach((damagedPart) => {
            if (!damagedPart.partDamages) disable = true
            if (
              damagedPart.partDamages &&
              damagedPart.partDamages.length === 0
            ) {
              disable = true
            }
          })
        })
      })
      this.btnAddAllDamagesIsDisabled = disable
    },

    updateMultidamageState() {
      const multiDamage = {
        propertyType: this.propertyType,
        assets: INTERIOR_PROPERTY,
        damages: this.multidamagePieces
      }

      this.mutWarrantyUpdateMultidamage(multiDamage)
    },

    /**
     * Pushes the params for the damages-view route
     */
    routeToPartsView() {
      this.$router
        .push({
          name: 'damaged-parts',
          params: {
            propertyType: this.propertyType,
            damageType: INTERIOR_PROPERTY,
            damagedItem: MULTIDAMAGE
          }
        })
        .catch((e) => {})
    },

    /**
     * Pushes the params for the damages-view route
     */
    routeToDamagesView() {
      this.$router
        .push({
          name: 'damages-view'
        })
        .catch((e) => {})
    },

    /**
     * Clears all state properties
     */
    clearState() {
      this.mutWarrantyClearForms()
      this.mutWarrantyClearReport()
      this.mutWarrantyClearReportByCategory()
      this.mutWarrantyClearReportMurs()
      this.mutWarrantyClearSelectedDamagedParts()
    },

    /**
     * Clear selected report
     */
    clearSelectedReport() {
      this.selectedDamageReport.PIECE = null
      this.selectedDamagedPart = null
      this.selectedAllDamagedParts = null
      this.selectedPieceId = null
      this.selectedPieceSurface = null
      this.selectedDamageIndex = null
    },

    /**
     * Trigger go to damagesView
     */
    handleClickPrevRoute() {
      this.clearState()
      this.updateMultidamageState()
      this.routeToPartsView()
    },

    /**
     * Remove damaged part
     */
    handleOnDeleteDamagedPart(pieceType, pieceId, partKey) {
      const pieces = this.multidamagePieces.find(
        (type) => type.damageKey === pieceType
      )
      const piece = pieces.pieces.find((piece) => piece.pieceId === pieceId)

      if (
        this.multidamagePieces.length === 1 &&
        piece.damagedParts.length === 1
      ) {
        this.clearState()
        this.routeToDamagesView()
        return
      }
      if (piece.damagedParts.length === 1) {
        if (pieces.pieces.length === 1) {
          this.multidamagePieces = this.multidamagePieces.filter(
            (type) => type.damageKey !== pieceType
          )
        } else {
          pieces.pieces = pieces.pieces.filter((p) => p.pieceId !== pieceId)
        }
      } else {
        piece.damagedParts = piece.damagedParts.filter(
          (part) => part.key !== partKey
        )
      }

      piece.id = generateUniqueId()
      this.checkFormValid()
    },

    /**
     * Remove damage
     */
    handleOnDeleteDamage(pieceType, pieceId, event) {
      const pieces = this.multidamagePieces.find(
        (type) => type.damageKey === pieceType
      ).pieces
      const piece = pieces.find((piece) => piece.pieceId === pieceId)
      const partDamages = piece.damagedParts.find(
        (part) => part.key === event.partKey
      ).partDamages

      partDamages.splice(event.damageIndex, 1)
      piece.id = generateUniqueId()
      this.checkFormValid()
    },

    /**
     * Edit damage
     */
    handleOnEditDamage(pieceType, pieceSurface, pieceId, event) {
      const pieces = this.multidamagePieces.find(
        (type) => type.damageKey === pieceType
      ).pieces
      const piece = pieces.find((piece) => piece.pieceId === pieceId)
      const damagedPart = piece.damagedParts.find(
        (part) => part.key === event.partKey
      )

      this.selectedDamageReport.PIECE = pieceType
      this.selectedDamagedPart = cloneDeep(damagedPart)
      this.selectedPieceId = pieceId
      this.selectedPieceSurface = pieceSurface
      this.selectedDamageIndex = event.damageIndex

      setTimeout(() => {
        this.$refs.multidamageForm.showModal()
      })
    },

    /**
     * Open the modal with the form corresponding to the damage
     */
    handleOnShowModal(pieceType, pieceSurface, pieceId, damagedPart) {
      this.mutWarrantyClearForms()

      // Set multidamageForm component props
      this.selectedDamageReport.PIECE = pieceType
      this.selectedDamagedPart = cloneDeep(damagedPart)
      this.selectedPieceId = pieceId
      this.selectedPieceSurface = pieceSurface
      this.selectedDamageIndex = null

      setTimeout(() => {
        this.$refs.multidamageForm.showModal()
      })
    },

    handlePhotoclaimModal(
      damagedLiteral,
      pieceType,
      pieceSurface,
      pieceId,
      damagedParts
    ) {
      this.mutWarrantyClearForms()
      // Set multidamageForm component props
      this.selectedDamageReport.PIECE = pieceType
      this.selectedAllDamagedParts = cloneDeep(damagedParts)
      this.selectedPieceId = pieceId
      this.selectedPieceSurface = pieceSurface
      this.selectedDamageIndex = null

      setTimeout(() => {
        this.$refs.photoclaimForm.showModal(damagedLiteral)
      })
    },
    /**
     *
     */
    handleOnSurfaceChange(pieceType, pieceId, value) {
      const pieces = this.multidamagePieces.find(
        (type) => type.damageKey === pieceType
      ).pieces
      const piece = pieces.find((piece) => piece.pieceId === pieceId)

      piece.pieceSurface = value

      this.updatePartsSurfaces(piece)
      this.checkFormValid()
    },

    handleSurfaceModal(modalIsOpen, damageKey, pieceId) {
      if (modalIsOpen) {
        this.surfaceModalIsOpen = true
        this.selectedDamagedPart = damageKey
        this.selectedPieceId = pieceId
      } else {
        this.surfaceModalIsOpen = false
        this.selectedDamagedPart = null
        this.selectedPieceId = null
      }
    },

    calculateSurface({ width, length }) {
      const footInSquareMeters = 0.8
      const widthInSquareMeters = width * footInSquareMeters
      const lengthInSquareMeters = length * footInSquareMeters
      const areaInSquareMeters = widthInSquareMeters * lengthInSquareMeters
      return areaInSquareMeters.toFixed(2)
    },

    handleCalculateSurface(value) {
      this.handleOnSurfaceChange(
        this.selectedDamagedPart,
        this.selectedPieceId,
        this.calculateSurface(value, value)
      )
      this.surfaceModalIsOpen = false
      this.selectedDamagedPart = null
      this.selectedPieceId = null
    },

    /**
     * Get new surfaceInput value by piece and update all its parts
     */
    updatePartsSurfaces(piece) {
      piece.damagedParts.forEach((damagedPart) => {
        if (damagedPart.partDamages) {
          damagedPart.partDamages.forEach((damage) => {
            if (damage.damages['ROOM_SURFACE'] != null) {
              damage.damages['ROOM_SURFACE'] = piece.pieceSurface
            }
          })
        }
      })
      maEventBus.$emit('accordion:resize')
    },

    /**
     * Update part damages
     */
    handleOnPartDamageAdded({ pieceType, pieceId, damagedPart }) {
      const typeIndex = this.multidamagePieces.findIndex(
        (type) => type.damageKey === pieceType
      )
      const pieceIndex = this.multidamagePieces[typeIndex].pieces.findIndex(
        (piece) => piece.pieceId === pieceId
      )
      const partIndex = this.multidamagePieces[typeIndex].pieces[
        pieceIndex
      ].damagedParts.findIndex((part) => part.key === damagedPart.key)

      this.multidamagePieces[typeIndex].pieces[pieceIndex].damagedParts[
        partIndex
      ] = cloneDeep(damagedPart)
      this.multidamagePieces[typeIndex].id = generateUniqueId()
      this.clearSelectedReport()
      this.checkFormValid()
    },

    handleOnPartDamageAddedFromPc(payload) {
      console.log(payload)

      const typeIndex = this.multidamagePieces.findIndex(
        (type) => type.damageKey === payload.pieceType
      )
      const pieceIndex = this.multidamagePieces[typeIndex].pieces.findIndex(
        (piece) => piece.pieceId === payload.pieceId
      )

      const partIndex = this.multidamagePieces[typeIndex].pieces[
        pieceIndex
      ].photoclaimDamagedParts.findIndex(
        (damagedPart) => damagedPart.key === payload.damagedPart.key
      )

      const spacePhotos =
        this.multidamagePieces[typeIndex].pieces[pieceIndex].spacePhotos

      const photoclaimPartDamaged =
        this.multidamagePieces[typeIndex].pieces[pieceIndex]
          .photoclaimDamagedParts[partIndex]

      let partDamage = payload.damagedPart.partDamages[payload.damageIndex]

      partDamage = {
        images: [...spacePhotos],
        damages: { ...partDamage.damages },
        description: 'Not Found',
        literal: partDamage.literal,
        damageConfirmed: true,
        asset_damages: partDamage.asset_damages
      }

      if (this.selectedDamageIndex === null) {
        photoclaimPartDamaged.partDamages.push(partDamage)
      } else {
        photoclaimPartDamaged.partDamages[this.selectedDamageIndex] = partDamage
      }

      this.$set(
        this.multidamagePieces[typeIndex].pieces[pieceIndex]
          .photoclaimDamagedParts,
        partIndex,
        cloneDeep(photoclaimPartDamaged)
      )

      maEventBus.$emit('accordion:resize')

      this.clearSelectedReport()
    },

    async handleConfirmPhotoclaimDamages(
      pieceType,
      damagedPiece,
      pcDamagedPart
    ) {
      console.log('pieceType', pieceType)
      console.log('damagedPiece', damagedPiece)
      console.log('pcDamagedPart', pcDamagedPart)

      const damages = {
        sinister_id:
          this.stateWarrantySinisterId || sessionStorage.getItem('sinId'),
        items: []
      }
      const commonDamageBody = {
        category:
          this.stateWarrantyCategoryId || sessionStorage.getItem('formId'),
        subcategory:
          this.stateWarrantySubtypeId ||
          localStorage.getItem('warranty_subtype_id')
      }
      const commonFormInfo = {
        propertyType: this.stateMultidamage.propertyType,
        ASSETS: this.stateMultidamage.assets
      }

      damagedPiece.photoclaimDamagedParts.forEach((damagedPart) => {
        if (damagedPart.key !== pcDamagedPart.key) return

        for (const damage of damagedPart.partDamages) {
          const support =
            damagedPart.key.indexOf('MUR') !== -1
              ? `${damage.damages.QUANTITY}MUR`
              : damagedPart.key
          if (damagedPart.key === 'NETTOYAGE') {
            damage.damages.UNITS = '1'
          }
          const damageReport = {
            ...commonDamageBody,
            piece_id: damagedPiece.pieceId,
            images: damage.images,
            form_info: {
              ...commonFormInfo,
              PIECE: pieceType,
              SUPPORT: support,
              ...damage.damages,
              asset_damages: damage.asset_damages
            }
          }

          damages.items.push(damageReport)
        }
      })

      console.log('FINAL', damages)

      await apiPatchMultiDamages(damages)
        .then(() => {
          const typeIndex = this.multidamagePieces.findIndex(
            (type) => type.damageKey === pieceType
          )
          const pieceIndex = this.multidamagePieces[typeIndex].pieces.findIndex(
            (piece) => piece.pieceId === damagedPiece.pieceId
          )

          const partIndex = this.multidamagePieces[typeIndex].pieces[
            pieceIndex
          ].photoclaimDamagedParts.findIndex(
            (damagedPart) => damagedPart.key === pcDamagedPart.key
          )

          const partDamaged =
            this.multidamagePieces[typeIndex].pieces[pieceIndex]
              .photoclaimDamagedParts[partIndex]

          partDamaged.partDamages.forEach(
            (damage) => (damage.damageConfirmed = true)
          )

          partDamaged.damagesSended = true

          this.$set(
            this.multidamagePieces[typeIndex].pieces[pieceIndex]
              .photoclaimDamagedParts,
            partIndex,
            cloneDeep(partDamaged)
          )

          //this.updateMultidamageState()

          const finished = this.multidamagePieces[typeIndex].pieces[
            pieceIndex
          ].photoclaimDamagedParts.every((pcPart) => pcPart.damagesSended)

          maEventBus.$emit('accordion:resize')

          if (finished) {
            this.clearState()
            this.mutWarrantyUpdateMultidamage({})
            this.routeToDamagesView()
          }
        })
        .catch((err) => {
          // Send sentry custom event
          /* const scope = new Sentry.Scope()
          scope.setTag('section', 'multiDamage Add')
          scope.setContext({ damageData: damages })
          Sentry.captureException(
            new Error('Error in multidamage call'),
            () => scope
          ) */

          const errs = [400, 500, 404]
          const errCode =
            errs.find((errCode) => err.response.status === errCode) || 404
          const messageNotification = this.$t(
            `notifications.error.${errCode}.title`
          )
          window.scrollTo(0, 0)
          this.throwNotification(messageNotification, messageNotification, 'KO')
        })
        .finally(() => {
          this.loading = false
        })
    },

    handleOnAddPhotoclaimDamage({ damagedPiece, damagedKey, damagePart }) {
      console.log(damagedPiece)
      console.log(damagePart)

      const pieces = this.multidamagePieces.find(
        (type) => type.damageKey === damagedKey
      ).pieces

      const piece = pieces.find(
        (piece) => piece.pieceId === damagedPiece.pieceId
      )

      const damagedPart = piece.photoclaimDamagedParts.find(
        (part) => part.key === damagePart.key
      )

      this.selectedDamageReport.PIECE = damagedKey
      this.selectedDamagedPart = cloneDeep(damagedPart)
      this.selectedPieceId = damagedPiece.pieceId
      this.selectedPieceSurface = damagedPiece.pieceSurface
      this.selectedDamageIndex = null

      setTimeout(() => {
        this.$refs.multidamagePcForm.showModal()
      })
    },

    handleOnEditPhotoclaimDamage({
      damagedPiece,
      damagedKey,
      damagePart,
      damageIndex
    }) {
      console.log(damagedPiece)
      console.log(damagePart)
      console.log(damageIndex)

      const pieces = this.multidamagePieces.find(
        (type) => type.damageKey === damagedKey
      ).pieces

      const piece = pieces.find(
        (piece) => piece.pieceId === damagedPiece.pieceId
      )

      const damagedPart = piece.photoclaimDamagedParts.find(
        (part) => part.key === damagePart.key
      )

      this.selectedDamageReport.PIECE = damagedKey
      this.selectedDamagedPart = cloneDeep(damagedPart)
      this.selectedPieceId = damagedPiece.pieceId
      this.selectedPieceSurface = damagedPiece.pieceSurface
      this.selectedDamageIndex = damageIndex

      setTimeout(() => {
        this.$refs.multidamagePcForm.showModal()
      })
    },

    handleOnDeletePhotoclaimDamage(damageKey, payload) {
      const typeIndex = this.multidamagePieces.findIndex(
        (type) => type.damageKey === damageKey
      )
      const pieceIndex = this.multidamagePieces[typeIndex].pieces.findIndex(
        (piece) => piece.pieceId === payload.damagedPiece.pieceId
      )

      const partIndex = this.multidamagePieces[typeIndex].pieces[
        pieceIndex
      ].damagedParts.findIndex((part) => part.key === payload.damagePart.key)

      const photoclaimPartDamaged =
        this.multidamagePieces[typeIndex].pieces[pieceIndex]
          .photoclaimDamagedParts[partIndex]

      photoclaimPartDamaged.partDamages.splice(payload.damageIndex, 1)

      this.$set(
        this.multidamagePieces[typeIndex].pieces[pieceIndex]
          .photoclaimDamagedParts,
        partIndex,
        cloneDeep(photoclaimPartDamaged)
      )
      maEventBus.$emit('accordion:resize')
    },

    async handleOnAllPartsDamageAdded(partsAddedObject) {
      const { damagedParts, pieceType, pieceId, spacePhotos } = partsAddedObject

      const typeIndex = this.multidamagePieces.findIndex(
        (type) => type.damageKey === pieceType
      )
      const pieceIndex = this.multidamagePieces[typeIndex].pieces.findIndex(
        (piece) => piece.pieceId === pieceId
      )

      this.multidamagePieces[typeIndex].pieces[pieceIndex].photosTaken = true
      this.multidamagePieces[typeIndex].pieces[pieceIndex].spacePhotos =
        spacePhotos
      this.multidamagePieces[typeIndex].pieces[
        pieceIndex
      ].photoclaimDamagedParts = damagedParts
      this.multidamagePieces[typeIndex].id = generateUniqueId()
      this.clearSelectedReport()
      this.checkFormValid()
    },

    /**
     * Save all damages
     */
    async handleOnAddMultidamage() {
      this.loading = true

      const damages = {
        sinister_id:
          this.stateWarrantySinisterId || sessionStorage.getItem('sinId'),
        items: []
      }
      const commonDamageBody = {
        category:
          this.stateWarrantyCategoryId || sessionStorage.getItem('formId'),
        subcategory:
          this.stateWarrantySubtypeId ||
          localStorage.getItem('warranty_subtype_id')
      }
      const commonFormInfo = {
        propertyType: this.stateMultidamage.propertyType,
        ASSETS: this.stateMultidamage.assets
      }

      this.multidamagePieces.forEach((pieceType) => {
        pieceType.pieces.forEach((piece) => {
          piece.damagedParts.forEach((damagedPart) => {
            damagedPart.partDamages.forEach((damage) => {
              const support =
                damagedPart.key.indexOf('MUR') !== -1
                  ? `${damage.damages.QUANTITY}MUR`
                  : damagedPart.key
              if (damagedPart.key === 'NETTOYAGE') {
                damage.damages.UNITS = '1'
              }
              const damageReport = {
                ...commonDamageBody,
                piece_id: piece.pieceId,
                images: damage.images,
                form_info: {
                  ...commonFormInfo,
                  PIECE: pieceType.damageKey,
                  SUPPORT: support,
                  ...damage.damages,
                  asset_damages: damage.asset_damages
                }
              }
              damages.items.push(damageReport)
            })
          })
        })
      })

      await apiPatchMultiDamages(damages)
        .then(() => {
          this.clearState()
          this.mutWarrantyUpdateMultidamage({})
          this.routeToDamagesView()
        })
        .catch((err) => {
          // Send sentry custom event
          /* const scope = new Sentry.Scope()
          scope.setTag('section', 'multiDamage Add')
          scope.setContext({ damageData: damages })
          Sentry.captureException(
            new Error('Error in multidamage call'),
            () => scope
          ) */

          const errs = [400, 500, 404]
          const errCode =
            errs.find((errCode) => err.response.status === errCode) || 404
          const messageNotification = this.$t(
            `notifications.error.${errCode}.title`
          )
          window.scrollTo(0, 0)
          this.throwNotification(messageNotification, messageNotification, 'KO')
        })
        .finally(() => {
          this.loading = false
        })
    }
  },

  async mounted() {
    this.mutWarrantyClearForms()
    window.scrollTo(0, 0)
    if (this.isMultidamage) {
      this.multidamagePieces = cloneDeep(this.stateMultidamage).damages
      this.multidamagePieces.forEach((pieceType) => {
        pieceType.pieces.forEach((piece) => {
          if (piece.pieceSurface == null) piece.pieceSurface = 0
        })
      })
      this.someTypeBanned = this.multidamagePieces.some((damagePiece) =>
        damagePiece.pieces.some((piece) =>
          piece.damagedParts.some((part) => TYPES_BANNED.includes(part.key))
        )
      )
      this.checkFormValid()
    } else {
      this.clearState()
      this.routeToDamagesView()
    }
    setTimeout(() => {
      this.isExpanded = true
    }, 500)
  },

  beforeCreate: function () {
    if (!(WARRANTY_MODULE_NAME in this.$store.state)) {
      this.$store.registerModule(WARRANTY_MODULE_NAME, warrantyModule)
    }
  }
}
